// Settings dialog: analyser model configuration and the two whitelists.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.

export const settings: Record<string, string> = {
  'Configure AI models for invoice document processing.':
    'KI-Modelle für die Verarbeitung von Rechnungsdokumenten konfigurieren.',
  'OCR model (for scans)': 'OCR-Modell (für Scans)',
  'Extraction model': 'Extraktionsmodell',
  'Copy exact model IDs from openrouter.ai/models':
    'Exakte Modell-IDs von openrouter.ai/models übernehmen',
  'Add model': 'Modell hinzufügen',
  'OpenRouter API key (optional)': 'OpenRouter-API-Key (optional)',
  'For development only. In production the backend uses its own key.':
    'Nur für die Entwicklung. In der Produktion nutzt das Backend seinen eigenen Key.',
  'Settings are stored locally in your browser.':
    'Die Einstellungen werden lokal in deinem Browser gespeichert.',

  // Whitelists
  'Supplier whitelist': 'Lieferanten-Whitelist',
  'Recipient whitelist': 'Empfänger-Whitelist',
  'Add supplier': 'Lieferant hinzufügen',
  'Add recipient': 'Empfänger hinzufügen',
  'Supplier added': 'Lieferant hinzugefügt',
  'Recipient added': 'Empfänger hinzugefügt',
  'Add a new supplier to the whitelist': 'Neuen Lieferanten zur Whitelist hinzufügen',
  'Add a new recipient to the whitelist': 'Neuen Empfänger zur Whitelist hinzufügen',
  'Normalised name': 'Normalisierter Name',
  'Name variations (comma-separated)': 'Namensvarianten (kommagetrennt)',
  'Different ways this supplier might appear on invoices':
    'Schreibweisen, in denen dieser Lieferant auf Rechnungen auftauchen kann',
  'Different ways this recipient might appear on invoices':
    'Schreibweisen, in denen dieser Empfänger auf Rechnungen auftauchen kann',
  'Add to whitelist': 'Zur Whitelist hinzufügen',
  'Loading whitelist …': 'Whitelist wird geladen …',
  'Could not load the whitelist': 'Die Whitelist konnte nicht geladen werden',
  'Please fill in all required fields': 'Bitte alle Pflichtfelder ausfüllen',
  'Could not delete the supplier': 'Der Lieferant konnte nicht gelöscht werden',
  'Could not delete the recipient': 'Der Empfänger konnte nicht gelöscht werden',
  'No suppliers in the whitelist yet — add the first one above.':
    'Noch keine Lieferanten in der Whitelist — den ersten oben hinzufügen.',
  'No recipients in the whitelist yet — add the first one above.':
    'Noch keine Empfänger in der Whitelist — den ersten oben hinzufügen.',
  Variations: 'Varianten',
  'Suppliers in the whitelist': 'Lieferanten in der Whitelist',
  'Recipients in the whitelist': 'Empfänger in der Whitelist',
}
